import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=e619cd26&"
import script from "./ResponsiveImage.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e619cd26', component.options)
    } else {
      api.reload('e619cd26', component.options)
    }
    module.hot.accept("./ResponsiveImage.vue?vue&type=template&id=e619cd26&", function () {
      api.rerender('e619cd26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/ResponsiveImage.vue"
export default component.exports